// @flow
import React, { createContext, useState, useContext, useMemo } from 'react';

type Props = {
    children: React$Element<any>,
};

const RescheduleContext = createContext({
    rescheduleFlow: false,
    startRescheduleFlow: () => {},
    stopRescheduleFlow: () => {},
    otp: '',
    setOtp: () => {},
    slots: null,
    setSlots: () => {},
    rescheduleSuccess: false,
    setRescheduleSuccess: () => {},
    fetchingFreshTripData: false,
    startedFetchingFreshTripData: () => {},
    stoppedFetchingFreshTripData: () => {},
});

const RescheduleProvider = ({ children }: Props): React$Element<any> => {
    const [rescheduleFlow, setRescheduleFlow] = useState(false);
    const [otp, setOtp] = useState('');
    const [slots, setSlots] = useState(null);
    const [rescheduleSuccess, setRescheduleSuccess] = useState(false);
    const [fetchingFreshTripData, setFetchingFreshTripData] = useState(false);

    const startRescheduleFlow = React.useCallback(
        () => setRescheduleFlow(true),
        []
    );
    const stopRescheduleFlow = React.useCallback(() => {
        setRescheduleFlow(false);
        setSlots(null);
        setOtp('');
    }, []);

    const startedFetchingFreshTripData = React.useCallback(() => {
        setRescheduleSuccess(false);
        setFetchingFreshTripData(true);
    }, []);

    const stoppedFetchingFreshTripData = React.useCallback(() => {
        setFetchingFreshTripData(false);
    }, []);

    const value = useMemo(
        () => ({
            rescheduleFlow,
            startRescheduleFlow,
            stopRescheduleFlow,
            otp,
            setOtp,
            slots,
            setSlots,
            rescheduleSuccess,
            setRescheduleSuccess,
            fetchingFreshTripData,
            startedFetchingFreshTripData,
            stoppedFetchingFreshTripData,
        }),
        [
            fetchingFreshTripData,
            otp,
            rescheduleFlow,
            rescheduleSuccess,
            slots,
            startRescheduleFlow,
            startedFetchingFreshTripData,
            stopRescheduleFlow,
            stoppedFetchingFreshTripData,
        ]
    );

    return (
        <RescheduleContext.Provider value={value}>
            {children}
        </RescheduleContext.Provider>
    );
};

const useRescheduleContext = (): any => {
    const context = useContext(RescheduleContext);
    return context;
};

export { useRescheduleContext, RescheduleProvider };
